import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import BookmarkCoin from "./BookmarkCoin";
import { DefaultUrlWeb } from "config/Configuration";
import Modal from "./Modal";
import { CloseSmall } from "assets/Icon";

function WalletActions({ open, onClose, coin, items, hideBookmark }) {
  const theme = useTheme();

  return (
    <Modal
      title={
        <WalletActionHeader>
          <Box display="flex" alignItems="center">
            {!hideBookmark && (
              <BookMarkWrapper>
                <BookmarkCoin data={coin} />
              </BookMarkWrapper>
            )}

            <img
              src={
                DefaultUrlWeb + (coin?.coinSourceImageUrl || coin?.coinImageUrl)
              }
              alt=""
            />

            <Typography mt={0.5} ml={2} color="common.white">
              {coin?.coinName || coin?.coinSourceName}
            </Typography>
          </Box>

          <IconButton color="text" onClick={onClose}>
            <CloseSmall color={theme.palette.common.white} />
          </IconButton>
        </WalletActionHeader>
      }
      dir="ltr"
      hideContainer
      maxWidth="xs"
      open={open}
      onClose={onClose}
    >
      <Grid container>
        <Grid item xs={12}>
          <ListStyle>
            {items?.map((item) => (
              <ListItemStyle
                onClick={() => {
                  item?.onClick(coin);
                  onClose();
                }}
              >
                <IconWrapper>{item?.icon}</IconWrapper>

                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  variant="h6"
                  fontWeight={400}
                  ml={2}
                >
                  {item?.text}
                </Typography>

                <AnimatedIcon>
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </AnimatedIcon>
              </ListItemStyle>
            ))}
          </ListStyle>
        </Grid>
      </Grid>
    </Modal>
  );
}

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  padding: theme.spacing(1.5),
  cursor: "pointer",

  ".MuiBox-root": {
    transition: "all 0.3s",
    opacity: 0,
  },

  "&:hover": {
    ".MuiBox-root": {
      opacity: 1,
      transform: "translate(0, -50%)",
    },
  },
}));

const AnimatedIcon = styled(Box)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(2),
  top: "50%",
  transform: "translate(-10px, -50%)",
}));

const WalletActionHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1),
  background: theme.palette.background.headerModal,
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  paddingLeft: theme.spacing(4),

  img: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
  },
}));

const ListStyle = styled(List)(() => ({
  paddingBottom: 0,
}));

const BookMarkWrapper = styled(Box)(() => ({
  position: "absolute",
  left: "-8px",
}));

const IconWrapper = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: theme.spacing(3),
}));

export default WalletActions;
